export default "__VITE_ASSET__CLy3wFeD__"